/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Map of available signing flow types with their properties.
 */
export const SIGNING_FLOW_TYPE_MAP = {
    signIn: {
        name: 'login',
        eventName: 'Sign In',
    },
    signUp: {
        name: 'join',
        eventName: 'Sign Up',
    },
    socialSignUp: {
        eventName: 'Social Sign Up',
    },
    social: {
        name: 'social',
        eventName: 'Social',
    },
} as const;

/**
 * Represents the type of signing flow completed.
 *
 * @interface SigningFlowType
 */
export type SigningFlowType = ValueOf<typeof SIGNING_FLOW_TYPE_MAP>;
